import React, { useContext, useEffect, useMemo, useState } from "react"
import { Card, Modal, ModalBody, CardBody } from "reactstrap"
import { useClientContext } from "../ClientContextBox"
import { axiosbaseurl } from "configure"
import LoadingButton from "components/Common/LoadingButton"
import moment from "moment"
import { fixedIds } from "app_config"
import useLocationData from "custom hooks/useLocationData"
import { customStyles } from "helpers/select-styles"
import Select from "react-select"
import { validateContact } from "helpers/common_helper"

const INDIVIDUAL_TYPE_ID = 1

const StateCity = React.memo(function StateCity({
  state,
  setState,
  city,
  setCity,
  errors,
  isReadOnly,
}) {
  const { states, cities, handleStateChange } = useLocationData()

  useEffect(() => {
    if (state) handleStateChange(state)
  }, [state])

  return (
    <>
      <div className="col-md-4 mb-3">
        <label>
          Country <span className="text-danger">*</span>
        </label>
        <select
          onChange={e => {
            setState(e.target.value)
            setCity("")
          }}
          value={state}
          disabled={isReadOnly}
          className="form-select input-field"
        >
          <option value="">Select Country</option>
          {states.map(state => (
            <option key={state.isoCode} value={state.isoCode}>
              {state.name}
            </option>
          ))}
          <option value="Non-UK">Non-UK</option>
        </select>
        <span className="error">{errors.state}</span>
      </div>

      <div className="col-md-4 mb-3">
        <label>
          City <span className="text-danger">*</span>
        </label>
        {state == "Non-UK" ? (
          <input
            type="text"
            placeholder="Enter City"
            value={city}
            disabled={isReadOnly}
            onChange={e => setCity(e.target.value)}
            className="form-control input-field"
          />
        ) : (
          <Select
            value={city}
            onChange={e => setCity(e)}
            options={cities}
            styles={customStyles}
            placeholder="Select City"
            isDisabled={isReadOnly}
          />
        )}
        <span className="error">{errors.city}</span>
      </div>
    </>
  )
})

const CreateClient = ({
  changeStep,
  client_id,
  setClientCreated,
  setHasPractice,
}) => {
  const {
    isDataLoaded,

    errors,
    setErrors,
    isReadOnly,
    clientId,
    setClientId,
    client_type_options,
    client_status_options,
    connection_options,
    allConnectionClients,
    bookkeeper_options,
    bookkeeping_options,
    email,
    setEmail,
    password,
    setPassword,
    clientType,
    setClientType,
    clientName,
    setClientName,
    clientCode,
    setClientCode,
    haveTradingName,
    sethaveTradingName,
    tradingName,
    settradingName,
    isRegisteredAddressAndCorrespondenceAddressSame,
    setisRegisteredAddressAndCorrespondenceAddressSame,
    correspondenceAddress,
    setcorrespondenceAddress,
    businessNature,
    setbusinessNature,
    haveWebsite,
    sethaveWebsite,
    websiteLink,
    setwebsiteLink,
    houseNumber,
    setHouseNumber,
    registeredAddress,
    setRegisteredAddress,
    tradingStatus,
    setTradingStatus,
    clientStatus,
    setClientStatus,
    connections,
    setConnections,

    doesBookkeeper,
    setDoesBookkeeper,
    bookkeeper,
    setBookkeeper,
    bookkeeping_system,
    setBookkeeping_system,

    setAccountsAndTaxCurrentYearDueDate,
    setAccountsAndTaxNextYearDueDate,
    setConfirmCurrentYearDueDate,
    setConfirmCSYearDueDate,
    confirmCurrentYearDueDate,
    confirmCSYearDueDate,
    accountsAndTaxCurrentYearDueDate,
    accountsAndTaxNextYearDueDate,

    // Personal / primary contact fields
    prefix_options,
    p_prefix,
    setPPrefix,
    p_forename,
    setPForename,
    p_surname,
    setPSurname,
    p_preferredName,
    setPPreferredName,
    p_dob,
    setPDob,
    p_occupation,
    setPOccupation,
    p_mobile,
    setPMobile,
    p_landline,
    setPLandline,
    p_address1,
    setPAddress1,
    p_address2,
    setPAddress2,
    p_city,
    setPCity,
    p_country,
    setPCountry,
    p_postcode,
    setPPostcode,
    p_contactDescription,
    setPContactDescription,
    isPrimaryAbsence,
    setisPrimaryAbsence,
    sameDetails,
    setSameDetails,
    s_prefix,
    setSPrefix,
    s_forename,
    setSForename,
    s_surname,
    setSSurname,
    s_email,
    setSEmail,
    s_preferredName,
    setSPreferredName,
    s_dob,
    setSDob,
    s_occupation,
    setSOccupation,
    s_mobile,
    setSMobile,
    s_landline,
    setSLandline,
    s_address1,
    setSAddress1,
    s_address2,
    setSAddress2,
    s_city,
    setSCity,
    s_country,
    setSCountry,
    s_postcode,
    setSPostcode,
    s_contactDescription,
    setSContactDescription,
    auditLogs,
    setAuditLogs,

    setIsChanged,
  } = useClientContext()

  const [bookKeeperDetails, setBookKeeperDetails] = useState(null)
  const [statusStyle, setStatusStyle] = useState({})
  const [loading, setLoading] = useState(false)

  const [popup, setPopup] = useState(false)
  const [isFetched, setIsFetched] = useState(false)

  // history modal — used by the "Updated history" button (Individual only)
  const [show, setShow] = useState(false)
  const [history, setHistory] = useState([])

  const [number, setnumber] = useState("")
  const [connTab, setConnTab] = useState("")

  const isIndividual = Number(clientType) === INDIVIDUAL_TYPE_ID
  const isEditMode = !!(client_id || clientId)

  useEffect(() => {
    if (connections?.length) setConnTab(connections[0]?.value)
  }, [connections])

  // company House popup — only for non-Individual new clients
  useEffect(() => {
    if (
      !houseNumber &&
      !registeredAddress &&
      !tradingStatus &&
      !client_id &&
      !isIndividual
    )
      setPopup(true)
  }, [])

  // manage account & tax dates based on clientType
  useEffect(() => {
    if ([fixedIds.individual, fixedIds.partnership].includes(clientType)) {
      const currentDate = moment()
      const firstDate = moment().month(3).date(5) // 5th April
      const secondDate = moment().month(0).date(31) // 31st January

      if (currentDate.isAfter(firstDate)) {
        setAccountsAndTaxCurrentYearDueDate(
          firstDate.add(1, "year").format("YYYY-MM-DD")
        )
        setAccountsAndTaxNextYearDueDate(
          secondDate.add(2, "year").format("YYYY-MM-DD")
        )
      } else {
        setAccountsAndTaxCurrentYearDueDate(firstDate.format("YYYY-MM-DD"))
        setAccountsAndTaxNextYearDueDate(
          secondDate.add(1, "year").format("YYYY-MM-DD")
        )
      }
    }
  }, [clientType])

  useEffect(() => {
    if (bookkeeper) {
      setBookKeeperDetails(
        bookkeeper_options.find(item => item.id === Number(bookkeeper))
      )
    }

    if (clientStatus) {
      const colorCode = client_status_options.find(
        item => item.id === Number(clientStatus)
      )?.colorCode
      setStatusStyle({ backgroundColor: colorCode, color: "#fff" })
    } else {
      setStatusStyle({})
    }
  }, [bookkeeper, clientStatus, client_status_options, bookkeeper_options])

  function isLimitedCompany() {
    return (
      client_type_options
        ?.find(item => item.id === Number(clientType))
        ?.clientType?.toLowerCase() === "limited company"
    )
  }

  // ── Same-details toggle for secondary contact ─────────────────────────────
  useEffect(() => {
    handleSameDetails()
  }, [sameDetails])

  const handleSameDetails = () => {
    if (sameDetails) {
      setSPrefix(p_prefix)
      setSForename(p_forename)
      setSSurname(p_surname)
      setSEmail(email)
      setSPreferredName(p_preferredName)
      setSDob(p_dob)
      setSOccupation(p_occupation)
      setSMobile(p_mobile)
      setSLandline(p_landline)
      setSAddress1(p_address1)
      setSAddress2(p_address2)
      setSCity(p_city)
      setSCountry(p_country)
      setSPostcode(p_postcode)
      setSContactDescription(p_contactDescription)
    }
  }

  // ── Auto-derive clientName from Prefix + Forename + Surname (Individual) ──
  useEffect(() => {
    if (isIndividual && isDataLoaded) {
      const prefixLabel =
        prefix_options?.find(p => String(p.id) === String(p_prefix))
          ?.prefixName || ""
      const derived = [prefixLabel, p_forename, p_surname]
        .filter(Boolean)
        .join(" ")
      setClientName(derived)
    }
  }, [isIndividual, p_prefix, p_forename, p_surname, prefix_options])

  // ── Auto-derive registeredAddress from address fields (Individual) ─────────
  useEffect(() => {
    if (isIndividual && isDataLoaded) {
      console.log("p_country", p_country)
      const cityLabel =
        typeof p_city === "object" ? p_city?.value || "" : p_city || ""
      const derived = [p_address1, p_address2, cityLabel, p_country, p_postcode]
        .filter(Boolean)
        .join(", ")
      setRegisteredAddress(derived)
    }
  }, [isIndividual, p_address1, p_address2, p_city, p_country, p_postcode])

  // ── Validation ────────────────────────────────────────────────────────────
  const validate = () => {
    let tempErrors = {}

    // Always required
    if (!clientType) tempErrors.clientType = "Client Type is required."
    if (!clientStatus) tempErrors.clientStatus = "Client Status is required."
    if (!email || !/\S+@\S+\.\S+/.test(email))
      tempErrors.email = "Valid Email is required."

    if (doesBookkeeper === "yes") {
      if (!bookkeeper) tempErrors.bookkeeper = "Bookkeeper is required."
      if (!bookkeeping_system)
        tempErrors.bookkeeping_system = "Bookkeeping system is required."
    }

    if (isIndividual) {
      // Primary contact fields required for Individuals
      if (!p_prefix) tempErrors.p_prefix = "Prefix is required."
      if (!p_forename) tempErrors.p_forename = "Forename is required."
      if (!p_surname) tempErrors.p_surname = "Surname is required."
      if (!p_preferredName)
        tempErrors.p_preferredName = "Preferred Name is required."
      if (!p_dob) tempErrors.p_dob = "Date of Birth is required."
      if (!p_occupation) tempErrors.p_occupation = "Occupation is required."
      if (!p_mobile) tempErrors.p_mobile = "Contact Number 1 is required."
      if (!p_address1) tempErrors.p_address1 = "Address Line 1 is required."
      if (!p_city) tempErrors.p_city = "City is required."
      if (!p_country) tempErrors.p_country = "Country is required."
      if (!p_postcode) tempErrors.p_postcode = "Postcode is required."
      if (!businessNature)
        tempErrors.businessNature = "Business nature is required"

      // Secondary contact fields (only when secondary contact is enabled)
      if (isPrimaryAbsence === "yes") {
        if (!s_prefix) tempErrors.s_prefix = "Prefix is required."
        if (!s_forename) tempErrors.s_forename = "Forename is required."
        if (!s_surname) tempErrors.s_surname = "Surname is required."
        if (!s_preferredName)
          tempErrors.s_preferredName = "Preferred Name is required."
        if (!s_dob) tempErrors.s_dob = "Date of Birth is required."
        if (!s_occupation) tempErrors.s_occupation = "Occupation is required."
        if (!s_mobile) tempErrors.s_mobile = "Contact Number 1 is required."
        if (!s_address1) tempErrors.s_address1 = "Address Line 1 is required."
        if (!s_city) tempErrors.s_city = "City is required."
        if (!s_country) tempErrors.s_country = "Country is required."
        if (!s_postcode) tempErrors.s_postcode = "Postcode is required."
      }
    } else {
      // Non-Individual fields
      if (!clientName) tempErrors.clientName = "Client Name is required."
      if (!clientCode) tempErrors.clientCode = "Client Code is required."

      if (isLimitedCompany()) {
        if (!houseNumber)
          tempErrors.houseNumber = "Company House Number is required."
      }

      if (haveTradingName === "yes") {
        if (!tradingName) tempErrors.tradingName = "Trading name is required"
      }

      if (!businessNature)
        tempErrors.businessNature = "Business nature is required"

      if (haveWebsite === "yes") {
        if (!websiteLink) tempErrors.websiteLink = "Website link is required"
      }
    }

    setErrors(tempErrors)
    return Object.keys(tempErrors).length === 0
  }

  // ── Submit ────────────────────────────────────────────────────────────────
  const handleSubmit = async () => {
    if (validate() && !isReadOnly) {
      swal({
        title: "Are you sure?",
        text: client_id
          ? `You want to save these details of ${clientName}.`
          : "You want to create this client.",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async willDelete => {
        if (willDelete) {
          try {
            setLoading(true)

            // Base payload shared by both types
            const post_data = {
              email,
              clientCode,
              clientTypeId: clientType,
              clientName,
              clientStatusId: clientStatus,
              haveBookeeper: doesBookkeeper,
              bookeeperId: bookkeeper,
              bookeepingSystemId: bookkeeping_system,
              isRegisteredAddressAndCorrespondenceAddressSame,
              correspondenceAddress,
              businessNature,
              haveWebsite,
              websiteLink,
              registeredAddress,
              trading: tradingStatus,
              haveTradingName,
              tradingName,
              confirmCurrentYearDueDate,
              confirmCSYearDueDate,
              accountsAndTaxCurrentYearDueDate,
              accountsAndTaxNextYearDueDate,
            }

            if (isIndividual) {
              // Individual: personal details merged in; registeredAddress is auto-derived
              Object.assign(post_data, {
                registeredAddress,
                primaryPrefixId: p_prefix,
                primaryForename: p_forename,
                primaryEmail: email,
                primarySurname: p_surname,
                primaryPreferredName: p_preferredName,
                primaryDOB: p_dob,
                primaryOccupation: p_occupation,
                primaryMobile: p_mobile,
                primaryLandline: p_landline,
                primaryAddressLine1: p_address1,
                primaryAddressLine2: p_address2,
                primaryCity: p_city?.value || p_city,
                primaryCountry: p_country,
                primaryPostcode: p_postcode,
                primaryContactDescription: p_contactDescription,
                haveSecondaryContact: isPrimaryAbsence,
                sameAsPrimaryDetails: sameDetails,
                secondaryPrefixId: s_prefix,
                secondaryForename: s_forename,
                secondarySurname: s_surname,
                secondaryEmail: s_email,
                secondaryPreferredName: s_preferredName,
                secondaryDOB: s_dob,
                secondaryOccupation: s_occupation,
                secondaryMobile: s_mobile,
                secondaryLandline: s_landline,
                secondaryAddressLine1: s_address1,
                secondaryAddressLine2: s_address2,
                secondaryCity: s_city?.value || s_city,
                secondaryCountry: s_country,
                secondaryPostcode: s_postcode,
                secondaryContactDescription: s_contactDescription,
              })
            } else {
              // Non-Individual: standard client fields
              Object.assign(post_data, {
                companyHouseNumber: houseNumber,
              })
            }

            let response
            if (client_id || clientId) {
              response = await axiosbaseurl.put(
                `/client/${client_id || clientId}`,
                post_data
              )
            } else {
              response = await axiosbaseurl.post("/client", post_data)
            }

            if (response.data.success) {
              if (response.data.data?.clientCode)
                setClientCode(response.data.data?.clientCode)

              setClientId(response.data.data.id)
              setIsChanged(prev => ({ ...prev, 0: false }))

              swal("", "Details saved successfully", "success").then(() => {
                if (response.data.data?.hasPractice) {
                  changeStep(2)
                } else {
                  changeStep(5) // switch to practice page
                  setHasPractice(false)
                }
                setClientCreated(true)
              })
            }
          } catch (error) {
            console.log(error)
            const msg =
              error.response.data.message ||
              error.message ||
              "Something went Wrong"

            swal(
              "",
              msg,
              msg.includes("No changes were made !") ||
                msg.includes("Client Code already exists!") ||
                msg.includes(
                  "Email already in use by an employee, please use another email address."
                )
                ? "warning"
                : "error"
            )
          } finally {
            setLoading(false)
          }
        }
      })
    } else window.scrollTo(0, 100)
  }

  // ── Company House API ─────────────────────────────────────────────────────
  const handleApi = async e => {
    e.preventDefault()
    try {
      setLoading(true)

      const { data } = await axiosbaseurl.get(`/company/${number}`)

      if (data) {
        setHouseNumber(data?.company_number)
        setClientName(data?.company_name)
        setRegisteredAddress(
          `${data?.registered_office_address?.address_line_1}, ${data?.registered_office_address?.postal_code}, ${data?.registered_office_address?.locality}`
        )

        setTradingStatus(data?.company_status)

        const ltdTypes = ["plc", "ltd", "private-limited-guarant-nsc"]

        if (ltdTypes.includes(data?.type)) {
          if (data?.accounts?.next_accounts?.period_end_on)
            setAccountsAndTaxCurrentYearDueDate(
              data?.accounts?.next_accounts?.period_end_on
            )

          if (data?.accounts?.next_accounts?.due_on)
            setAccountsAndTaxNextYearDueDate(
              data?.accounts?.next_accounts?.due_on
            )

          if (data?.confirmation_statement?.next_made_up_to)
            setConfirmCurrentYearDueDate(
              data?.confirmation_statement?.next_made_up_to
            )
          if (data?.confirmation_statement?.next_due)
            setConfirmCSYearDueDate(data?.confirmation_statement?.next_due)

          setClientType(3)
        }

        setPopup(false)
        setnumber("")
        // setIsFetched(true)
      }
    } catch (error) {
      console.log(error)
      swal(
        "",
        error.response.data.message || error.message || "Something went Wrong",
        "error"
      )
    } finally {
      setLoading(false)
    }
  }

  const currentConn = useMemo(
    () => allConnectionClients.find(c => c.id == connTab),
    [allConnectionClients, connTab]
  )

  const isValidURL = url => {
    const pattern =
      /^(https?:\/\/)([\w\-]+(\.[\w\-]+)+)([\/\w\-._~:?#[\]@!$&'()*+,;=]*)?$/
    return pattern.test(url)
  }

  return (
    <>
      <Card>
        <CardBody>
          {/* Client Details Section */}
          <div className="row mb-2">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h4 className="fw-bold mb-0">Client Details </h4>
              <div className="d-flex gap-2">
                {isIndividual && (
                  <div>
                    <button
                      type="button"
                      className="btn btn-sm btn-light"
                      onClick={() => {
                        setHistory(
                          auditLogs.filter(item => item.module === "CPD")
                        )
                        setShow(true)
                      }}
                    >
                      <i className="bx bx-history me-1"></i> Updated history
                    </button>
                  </div>
                )}
                <div>
                  {!isReadOnly && !isIndividual && (
                    <button
                      type="button"
                      onClick={() => setPopup(true)}
                      className="btn btn-sm btn-light"
                    >
                      Fetch Details by Company House Number
                    </button>
                  )}
                </div>
              </div>
            </div>

            {/* Client Type */}
            <div className="col-md-4 mb-3">
              <label>
                Client Type <span className="text-danger">*</span>
              </label>
              <select
                value={clientType}
                onChange={e => setClientType(e.target.value)}
                disabled={isReadOnly || isEditMode}
                className={`form-select input-field ${isReadOnly || isEditMode ? "bg-light" : ""}`}
              >
                <option value="">Select Client Type</option>
                {client_type_options
                  ?.slice()
                  .sort((a, b) => a.clientType.localeCompare(b.clientType))
                  .map(option => (
                    <option key={option.id} value={option.id}>
                      {option.clientType}
                    </option>
                  ))}
              </select>
              <span className="error">{errors.clientType}</span>
            </div>

            {/* Client Name */}
            <div className="col-md-4 mb-3">
              <label>
                Client Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                placeholder="Enter client name"
                value={clientName}
                disabled={isReadOnly || isIndividual}
                onChange={e => setClientName(e.target.value)}
                className={`form-control input-field ${
                  isReadOnly || isIndividual ? "bg-light" : ""
                } `}
              />
              <span className="error">{errors.clientName}</span>
            </div>

            {/* Client Code */}
            <div className="col-md-4 mb-3">
              <label>
                Client Code <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                placeholder="Enter client code"
                value={clientCode}
                disabled={isReadOnly}
                onChange={e => setClientCode(e.target.value)}
                className="form-control input-field"
              />
              <span className="error">{errors.clientCode}</span>
            </div>
          </div>

          {/* Prefix forename ... prefer name */}
          {isIndividual && (
            <div className="row mb-2">
              {/* Prefix */}
              <div className="col-md-4 mb-3">
                <label>
                  Prefix <span className="text-danger">*</span>
                </label>
                <select
                  disabled={isReadOnly}
                  value={p_prefix}
                  onChange={e => setPPrefix(e.target.value)}
                  className="form-select input-field"
                >
                  <option value="">Select </option>
                  {prefix_options
                    ?.slice()
                    .sort((a, b) => a.prefixName.localeCompare(b.prefixName))
                    .map(item => {
                      return (
                        <option key={item.id} value={item.id}>
                          {item.prefixName}
                        </option>
                      )
                    })}
                </select>
                <span className="error">{errors.p_prefix}</span>
              </div>

              {/* Forename */}
              <div className="col-md-4 mb-3">
                <label>
                  Forename <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter Forename"
                  disabled={isReadOnly}
                  className="form-control input-field"
                  value={p_forename}
                  onChange={e => setPForename(e.target.value)}
                />
                <span className="error">{errors.p_forename}</span>
              </div>

              {/* Surname */}
              <div className="col-md-4 mb-3">
                <label>
                  Surname <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter Surname"
                  disabled={isReadOnly}
                  className="form-control input-field"
                  value={p_surname}
                  onChange={e => setPSurname(e.target.value)}
                />
                <span className="error">{errors.p_surname}</span>
              </div>

              {/* Prefered name */}
              <div className="col-md-4 mb-3">
                <label>
                  Preferred Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter Preferred Name"
                  disabled={isReadOnly}
                  className="form-control input-field"
                  value={p_preferredName}
                  onChange={e => setPPreferredName(e.target.value)}
                />
                <span className="error">{errors.p_preferredName}</span>
              </div>
            </div>
          )}

          {/* Does client have trading name */}
          <div className="row mb-2">
            {/* Does client have trading name — hidden for Individuals */}
            {!isIndividual && (
              <div className="col-md-4 mb-3">
                <label>Does client have trading name?</label>{" "}
                <span className="text-danger">*</span>
                <div className="d-flex align-items-center">
                  <div>
                    <input
                      type="radio"
                      disabled={isReadOnly}
                      name="haveTradingName"
                      value={"yes"}
                      onChange={e => sethaveTradingName(e.target.value)}
                      checked={haveTradingName === "yes"}
                    />{" "}
                    Yes
                  </div>
                  <div className="ms-3">
                    <input
                      type="radio"
                      disabled={isReadOnly}
                      name="haveTradingName"
                      value={"no"}
                      onChange={e => sethaveTradingName(e.target.value)}
                      checked={haveTradingName === "no"}
                    />{" "}
                    No
                  </div>
                </div>
              </div>
            )}

            {!isIndividual && haveTradingName === "yes" && (
              <>
                <div className="col-md-4 mb-3">
                  <label>
                    Trading Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter trading name"
                    value={tradingName}
                    disabled={isReadOnly}
                    onChange={e => settradingName(e.target.value)}
                    className="form-control input-field"
                  />
                  <span className="error">{errors.tradingName}</span>
                </div>
              </>
            )}

            {/* Comp House Number */}
            {!isIndividual && (
              <div className="col-md-4 mb-3">
                <label>
                  Companies House Number
                  {isLimitedCompany() && (
                    <span className="text-info ps-1">*</span>
                  )}
                </label>
                <input
                  type="text"
                  placeholder="Enter company house number"
                  value={houseNumber}
                  onChange={e => setHouseNumber(e.target.value)}
                  disabled={isReadOnly}
                  className="form-control input-field"
                  maxLength={8}
                />
                <span className="error">{errors.houseNumber}</span>
              </div>
            )}

            {/* Comp House Status */}
            {!isIndividual && (
              <div className="col-md-4 mb-3">
                <label>Company House Status</label>
                <div className="form-control input-field view-field text-capitalize">
                  {tradingStatus || "Not Available"}
                </div>
              </div>
            )}
          </div>

          <div className="row mb-2">
            {/* Email */}
            <div className="col-md-4 mb-3">
              <label>
                Email Address <span className="text-danger">*</span>
              </label>
              <input
                type="email"
                placeholder="Enter email address "
                value={email}
                disabled={isReadOnly}
                onChange={e => setEmail(e.target.value.toLowerCase())}
                className="form-control input-field"
              />
              <span className="error">{errors.email}</span>
            </div>

            {/* Client Status */}
            <div className="col-md-4 mb-md-0 mb-3">
              <label>
                Client Status <span className="text-danger">*</span>
              </label>
              <select
                className="form-select input-field status_select_dropdown"
                style={statusStyle}
                value={clientStatus}
                disabled={isReadOnly}
                onChange={e => setClientStatus(e.target.value)}
              >
                <option value="">Select Status</option>
                {client_status_options
                  ?.slice()
                  .sort((a, b) => a.statusName.localeCompare(b.statusName))
                  ?.map(option => (
                    <option key={option.id} value={option.id}>
                      {option.statusName}
                    </option>
                  ))}
              </select>
              <span className="error">{errors.clientStatus}</span>
            </div>
          </div>

          {isIndividual && (
            <div className="row mb-2">
              {/* DOB */}
              <div className="col-md-4 mb-3">
                <label>
                  Date of Birth <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  disabled={isReadOnly}
                  className="form-control input-field"
                  value={p_dob}
                  onChange={e => setPDob(e.target.value)}
                  max={new Date().toISOString().split("T")[0]}
                />
                <span className="error">{errors.p_dob}</span>
              </div>

              {/* Occupation */}
              <div className="col-md-4 mb-3">
                <label>
                  Occupation <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter Occupation"
                  disabled={isReadOnly}
                  className="form-control input-field"
                  value={p_occupation}
                  onChange={e => setPOccupation(e.target.value)}
                />
                <span className="error">{errors.p_occupation}</span>
              </div>

              {/* Contact Number 1 */}
              <div className="col-md-4 mb-3">
                <label>
                  Contact Number 1 <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter Contact Number 1"
                  disabled={isReadOnly}
                  className="form-control input-field"
                  value={p_mobile}
                  onChange={e => setPMobile(e.target.value)}
                  onKeyDown={validateContact}
                />
                <span className="error">{errors.p_mobile}</span>
              </div>

              {/* Contact Number 2  */}
              <div className="col-md-4 mb-3">
                <label>Contact Number 2 </label>
                <input
                  type="text"
                  placeholder="Enter Contact Number 2"
                  disabled={isReadOnly}
                  className="form-control input-field"
                  value={p_landline}
                  onChange={e => setPLandline(e.target.value)}
                  onKeyDown={validateContact}
                />
              </div>

              {/* Address Line 1 */}
              <div className="col-md-4 mb-3">
                <label>
                  Address Line 1 <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter Address Line 1"
                  disabled={isReadOnly}
                  className="form-control input-field"
                  value={p_address1}
                  onChange={e => setPAddress1(e.target.value)}
                />
                <span className="error">{errors.p_address1}</span>
              </div>

              {/* Address Line 2 */}
              <div className="col-md-4 mb-3">
                <label>Address Line 2</label>
                <input
                  type="text"
                  placeholder="Enter Address Line 2"
                  disabled={isReadOnly}
                  className="form-control input-field"
                  value={p_address2}
                  onChange={e => setPAddress2(e.target.value)}
                />
              </div>

              <StateCity
                city={p_city}
                setCity={setPCity}
                state={p_country}
                setState={setPCountry}
                isReadOnly={isReadOnly}
                errors={{ city: errors.p_city, state: errors.p_country }}
              />

              {/* Postcode */}
              <div className="col-md-4 mb-3">
                <label>
                  Postcode <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter Postcode"
                  disabled={isReadOnly}
                  className="form-control input-field"
                  value={p_postcode}
                  onChange={e => setPPostcode(e.target.value)}
                />
                <span className="error">{errors.p_postcode}</span>
              </div>
            </div>
          )}

          {/* Additional Details */}
          <div className="row mb-2">
            {/* Registered Address */}
            <div className="col-12 mb-3">
              <label>Registered Address</label>
              <textarea
                placeholder="Enter registered address"
                value={registeredAddress}
                onChange={e => setRegisteredAddress(e.target.value)}
                disabled={isReadOnly || isIndividual}
                className={`form-control input-field ${
                  isReadOnly || isIndividual ? "bg-light" : ""
                } `}
                rows={3}
              ></textarea>
              <span className="error">{errors.registeredAddress}</span>
            </div>

            {/* registered address also the correspondence address */}
            <div className="col-md-12 mb-3">
              <label>
                Is the registered address also the correspondence address for
                this client?
              </label>{" "}
              <span className="text-danger">*</span>
              <div className="d-flex align-items-center">
                <div>
                  <input
                    type="radio"
                    disabled={isReadOnly}
                    name="isRegisteredAddressAndCorrespondenceAddressSame"
                    value={"yes"}
                    onChange={e =>
                      setisRegisteredAddressAndCorrespondenceAddressSame(
                        e.target.value
                      )
                    }
                    checked={
                      isRegisteredAddressAndCorrespondenceAddressSame === "yes"
                    }
                  />{" "}
                  Yes
                </div>
                <div className="ms-3">
                  <input
                    type="radio"
                    disabled={isReadOnly}
                    name="isRegisteredAddressAndCorrespondenceAddressSame"
                    value={"no"}
                    onChange={e =>
                      setisRegisteredAddressAndCorrespondenceAddressSame(
                        e.target.value
                      )
                    }
                    checked={
                      isRegisteredAddressAndCorrespondenceAddressSame === "no"
                    }
                  />{" "}
                  No
                </div>
              </div>
            </div>

            {/* Correspondence Address */}
            <div className="col-md-12 mb-3">
              <label>Correspondence Address</label>
              <textarea
                type="text"
                placeholder="Enter correspondence address"
                value={correspondenceAddress}
                disabled={
                  isReadOnly ||
                  isRegisteredAddressAndCorrespondenceAddressSame === "yes"
                }
                required={
                  isRegisteredAddressAndCorrespondenceAddressSame === "yes"
                }
                onChange={e => setcorrespondenceAddress(e.target.value)}
                className={`form-control input-field ${
                  isRegisteredAddressAndCorrespondenceAddressSame === "yes"
                    ? "bg-light"
                    : ""
                } `}
                rows={3}
              />
            </div>

            {/* client's nature of business */}
            <div className="col-md-12 mb-3">
              <label>
                What is the client's nature of business ?{" "}
                <span className="text-danger">*</span>
              </label>
              <textarea
                type="text"
                placeholder="Enter client's nature of business"
                value={businessNature}
                disabled={isReadOnly}
                onChange={e => setbusinessNature(e.target.value)}
                className="form-control input-field"
                rows={3}
              />
              <span className="error">{errors.businessNature}</span>
            </div>

            {/* Does client have a website */}
            <div className="col-md-4 mb-3">
              <label>Does client have a website?</label>{" "}
              <span className="text-danger">*</span>
              <div className="d-flex align-items-center">
                <div>
                  <input
                    type="radio"
                    disabled={isReadOnly}
                    name="haveWebsite"
                    value={"yes"}
                    onChange={e => sethaveWebsite(e.target.value)}
                    checked={haveWebsite === "yes"}
                  />{" "}
                  Yes
                </div>
                <div className="ms-3">
                  <input
                    type="radio"
                    disabled={isReadOnly}
                    name="haveWebsite"
                    value={"no"}
                    onChange={e => sethaveWebsite(e.target.value)}
                    checked={haveWebsite === "no"}
                  />{" "}
                  No
                </div>
              </div>
            </div>

            {haveWebsite === "yes" && (
              <>
                <div className="col-md-8 mb-3">
                  <label>
                    Website Link <span className="text-danger">*</span>
                  </label>
                  <input
                    type="url"
                    placeholder="Enter website link"
                    value={websiteLink}
                    disabled={isReadOnly}
                    pattern="https?://.+"
                    title="Please enter a valid URL starting with http:// or https://"
                    onChange={e => setwebsiteLink(e.target.value)}
                    onBlur={e => {
                      const value = e.target.value
                      if (value && !isValidURL(value)) {
                        swal(
                          "Invalid link format",
                          "Please enter a valid URL starting with http:// or https://",
                          "warning"
                        )
                        setwebsiteLink("")
                      }
                    }}
                    className="form-control input-field"
                  />
                  <span className="error">{errors.websiteLink}</span>
                </div>
              </>
            )}

            {connections?.length ? (
              <div className="col-12 mb-md-0 mb-3 mt-4">
                <div className="row">
                  <div className="col-md-3">
                    <h5 className="mb-3">Connections</h5>
                    {connections?.map(conn => {
                      return (
                        <button
                          key={conn.value}
                          onClick={() => setConnTab(conn.value)}
                          className={`btn text-start d-block w-100 rounded-0 border-bottom 
                                                        ${
                                                          conn.value ==
                                                            connTab &&
                                                          "btn-primary fw-bold"
                                                        }
                                                    `}
                        >
                          {conn.label}
                        </button>
                      )
                    })}
                  </div>
                  <div className="col-md-9">
                    {currentConn && (
                      <div>
                        <h5 className="mb-3">
                          Clients in {currentConn?.connectionName}
                        </h5>
                        <div>
                          <table className="table table-bordered">
                            <thead className="table-primary">
                              <tr>
                                <th>Client Name</th>
                                <th>Client Email</th>
                                <th>Client Code</th>
                              </tr>
                            </thead>
                            <tbody>
                              {currentConn?.clientsData?.map(c => (
                                <tr key={c.id}>
                                  <td>{c.clientName}</td>
                                  <td>{c.email}</td>
                                  <td>{c.clientCode}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          <div className="row mb-2">
            <h4 className="fw-bold mb-4">Client Responsibility</h4>

            <div className="col-md-12 mb-3">
              <label>Is there a third-party bookkeeper involved?</label>

              <div className="d-flex align-items-center">
                <div>
                  <input
                    type="radio"
                    disabled={isReadOnly}
                    name="doesbookkeeper"
                    value={"yes"}
                    onChange={e => setDoesBookkeeper(e.target.value)}
                    checked={doesBookkeeper === "yes"}
                  />{" "}
                  Yes
                </div>
                <div className="ms-3">
                  <input
                    type="radio"
                    disabled={isReadOnly}
                    name="doesbookkeeper"
                    value={"no"}
                    onChange={e => {
                      setDoesBookkeeper(e.target.value)
                      setBookkeeper(null)
                      setBookkeeping_system(null)
                    }}
                    checked={doesBookkeeper === "no"}
                  />{" "}
                  No
                </div>
              </div>
            </div>
            {doesBookkeeper === "yes" && (
              <>
                <div className="col-md-4 mb-3">
                  <label>
                    Bookkeeper <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select input-field"
                    disabled={isReadOnly}
                    value={bookkeeper}
                    onChange={e => setBookkeeper(e.target.value)}
                  >
                    <option value="">Select Bookkeeper</option>
                    {bookkeeper_options
                      ?.slice()
                      .sort((a, b) =>
                        a.preferredName.localeCompare(b.preferredName)
                      )
                      ?.map(option => (
                        <option key={option.id} value={option.id}>
                          {option.preferredName}
                        </option>
                      ))}
                  </select>
                  <span className="error">{errors.bookkeeper}</span>
                </div>

                <div className="col-md-4 mb-3">
                  <label>
                    Bookkeeping System <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select input-field"
                    disabled={isReadOnly}
                    value={bookkeeping_system}
                    onChange={e => setBookkeeping_system(e.target.value)}
                  >
                    <option value="">Select Bookkeeping System</option>
                    {bookkeeping_options
                      ?.slice()
                      .sort((a, b) =>
                        a.bookkeepingSystem.localeCompare(b.bookkeepingSystem)
                      )
                      ?.map(option => (
                        <option key={option.id} value={option.id}>
                          {option.bookkeepingSystem}
                        </option>
                      ))}
                  </select>
                  <span className="error">{errors.bookkeeping_system}</span>
                </div>
              </>
            )}

            {bookkeeper ? (
              <div className="col-md-12 mt-4">
                <table className="table ">
                  <thead className="table-primary">
                    <tr>
                      <th>Prefix</th>
                      <th>Forename</th>
                      <th>Surname</th>
                      <th>Preferred Name</th>
                      <th>Email</th>
                      <th>Contact Number</th>
                      <th>Employer Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{bookKeeperDetails?.prefixNameById?.prefixName}</td>
                      <td>{bookKeeperDetails?.forename}</td>
                      <td>{bookKeeperDetails?.surname}</td>
                      <td>{bookKeeperDetails?.preferredName}</td>
                      <td>{bookKeeperDetails?.email}</td>
                      <td>{bookKeeperDetails?.contactNumber}</td>
                      <td>{bookKeeperDetails?.tradingName}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            ) : null}
          </div>
        </CardBody>
      </Card>

      {isIndividual && (
        <Card>
          <CardBody>
            <div className="row mb-2">
              {/* Additional Primary Contact Notes */}
              <div className="col-md-12 mb-3">
                <label>Additional Primary Contact Notes</label>
                <textarea
                  type="text"
                  placeholder="Enter Additional Primary Contact Notes"
                  disabled={isReadOnly}
                  className="form-control input-field"
                  value={p_contactDescription}
                  onChange={e => setPContactDescription(e.target.value)}
                />
                <span className="error">{errors.p_contactDescription}</span>
              </div>

              {/* absense of primary contact */}
              <div className="col-md-8 mb-3">
                <label>
                  In absense of primary contact, can we reach out to a secondary
                  contact?
                </label>

                <div className="d-flex align-items-center">
                  <div>
                    <input
                      type="radio"
                      name="absence"
                      value={"yes"}
                      disabled={isReadOnly}
                      onChange={e => setisPrimaryAbsence(e.target.value)}
                      checked={isPrimaryAbsence === "yes"}
                    />{" "}
                    Yes
                  </div>
                  <div className="ms-3">
                    <input
                      type="radio"
                      name="absence"
                      value={"no"}
                      disabled={isReadOnly}
                      onChange={e => {
                        setisPrimaryAbsence(e.target.value)
                        // if (sameDetails)
                        //   setSameDetails(false)
                      }}
                      checked={isPrimaryAbsence === "no"}
                    />{" "}
                    No
                  </div>
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      )}

      {isIndividual && isPrimaryAbsence === "yes" && (
        <Card>
          <CardBody>
            <div className="row mb-2">
              <h4 className="fw-bold mb-3">Secondary Contact Details</h4>

              <div className="d-flex align-items-center mb-4">
                <div>Same as primary details </div>
                <div className="form-check form-switch form-switch-md ms-0 ps-3 mb-0 text-center">
                  <input
                    type="checkbox"
                    className="form-check-input fs-2 ms-0 me-0 "
                    style={{ left: 0 }}
                    disabled={isReadOnly}
                    checked={sameDetails}
                    onChange={e => {
                      setSameDetails(e.target.checked)
                      if (!e.target.checked) {
                        setSPrefix("")
                        setSForename("")
                        setSSurname("")
                        setSEmail("")
                        setSPreferredName("")
                        setSDob("")
                        setSOccupation("")
                        setSMobile("")
                        setSLandline("")
                        setSAddress1("")
                        setSAddress2("")
                        setSCity("")
                        setSCountry("")
                        setSPostcode("")
                        setSContactDescription("")
                      }
                    }}
                  />
                </div>
              </div>

              <div className="col-md-4 mb-3">
                <label>
                  Prefix <span className="text-danger">*</span>
                </label>
                <select
                  value={s_prefix}
                  onChange={e => setSPrefix(e.target.value)}
                  disabled={isReadOnly}
                  className="form-select input-field"
                >
                  <option value="">Select </option>
                  {prefix_options
                    ?.slice()
                    .sort((a, b) => a.prefixName.localeCompare(b.prefixName))
                    .map(item => {
                      return (
                        <option key={item.id} value={item.id}>
                          {item.prefixName}
                        </option>
                      )
                    })}
                </select>
                <span className="error">{errors.s_prefix}</span>
              </div>

              <div className="col-md-4 mb-3">
                <label>
                  Forename <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter Forename"
                  disabled={isReadOnly}
                  className="form-control input-field"
                  value={s_forename}
                  onChange={e => setSForename(e.target.value)}
                />
                <span className="error">{errors.s_forename}</span>
              </div>

              <div className="col-md-4 mb-3">
                <label>
                  Surname <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter Surname"
                  disabled={isReadOnly}
                  className="form-control input-field"
                  value={s_surname}
                  onChange={e => setSSurname(e.target.value)}
                />
                <span className="error">{errors.s_surname}</span>
              </div>

              <div className="col-md-4 mb-3">
                <label>
                  Preferred Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter Preferred Name"
                  disabled={isReadOnly}
                  className="form-control input-field"
                  value={s_preferredName}
                  onChange={e => setSPreferredName(e.target.value)}
                />
                <span className="error">{errors.s_preferredName}</span>
              </div>

              <div className="col-md-4 mb-3">
                <label>Email Address</label>
                <input
                  type="text"
                  placeholder="Enter Email Address"
                  disabled={isReadOnly}
                  className="form-control input-field"
                  value={s_email}
                  onChange={e => setSEmail(e.target.value)}
                />
              </div>

              <div className="col-md-4 mb-3">
                <label>
                  Date of Birth <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  className="form-control input-field"
                  disabled={isReadOnly}
                  value={s_dob}
                  onChange={e => setSDob(e.target.value)}
                  max={new Date().toISOString().split("T")[0]}
                />
                <span className="error">{errors.s_dob}</span>
              </div>

              <div className="col-md-4 mb-3">
                <label>
                  Occupation <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter Occupation"
                  disabled={isReadOnly}
                  className="form-control input-field"
                  value={s_occupation}
                  onChange={e => setSOccupation(e.target.value)}
                />
                <span className="error">{errors.s_occupation}</span>
              </div>

              <div className="col-md-4 mb-3">
                <label>
                  Contact Number 1 <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter Contact Number 1"
                  disabled={isReadOnly}
                  className="form-control input-field"
                  value={s_mobile}
                  onChange={e => setSMobile(e.target.value)}
                  onKeyDown={validateContact}
                />
                <span className="error">{errors.s_mobile}</span>
              </div>

              <div className="col-md-4 mb-3">
                <label>Contact Number 2</label>
                <input
                  type="text"
                  placeholder="Enter Contact Number 2"
                  className="form-control input-field"
                  value={s_landline}
                  onChange={e => setSLandline(e.target.value)}
                  disabled={isReadOnly}
                  onKeyDown={validateContact}
                />
              </div>

              <div className="col-md-4 mb-3">
                <label>
                  Address Line 1 <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter Address Line 1"
                  disabled={isReadOnly}
                  className="form-control input-field"
                  value={s_address1}
                  onChange={e => setSAddress1(e.target.value)}
                />
                <span className="error">{errors.s_address1}</span>
              </div>

              <div className="col-md-4 mb-3">
                <label>Address Line 2</label>
                <input
                  type="text"
                  placeholder="Enter Address Line 2"
                  disabled={isReadOnly}
                  className="form-control input-field"
                  value={s_address2}
                  onChange={e => setSAddress2(e.target.value)}
                />
              </div>

              <StateCity
                city={s_city}
                setCity={setSCity}
                state={s_country}
                setState={setSCountry}
                isReadOnly={isReadOnly}
                errors={{ city: errors.s_city, state: errors.s_country }}
              />

              <div className="col-md-4 mb-3">
                <label>
                  Postcode <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter Postcode"
                  disabled={isReadOnly}
                  className="form-control input-field"
                  value={s_postcode}
                  onChange={e => setSPostcode(e.target.value)}
                />
                <span className="error">{errors.s_postcode}</span>
              </div>
              <div className="col-md-12 mb-3">
                <label>Additional Secondary Contact Notes</label>
                <textarea
                  type="text"
                  placeholder="Enter Secondary Additional Contact Notes"
                  disabled={isReadOnly}
                  className="form-control input-field"
                  value={s_contactDescription}
                  onChange={e => setSContactDescription(e.target.value)}
                />
                <span className="error">{errors.p_contactDescription}</span>
              </div>
            </div>
          </CardBody>
        </Card>
      )}

      {!isReadOnly ? (
        <Card>
          <CardBody>
            <LoadingButton
              loading={loading}
              btnText="Save & Next"
              icon_2={<i className="fas fa-arrow-right ms-3"></i>}
              handler={handleSubmit}
            />
          </CardBody>
        </Card>
      ) : null}

      {/* Company house popup — non-Individual only */}
      {!isIndividual && (
        <Modal
          size="md"
          isOpen={popup}
          toggle={() => setPopup(!popup)}
          centered={true}
        >
          <div className="modal-content border-0 overflow-hidden">
            <ModalBody className="p-0">
              <div className="d-flex justify-content-between p-3 text-white  mb-4 border-bottom bg-primary">
                <h5 className="text-capitalize mb-0">
                  {" "}
                  Get details from Company House Number{" "}
                </h5>
                <button
                  type="button"
                  className="btn-close "
                  onClick={() => setPopup(!popup)}
                ></button>
              </div>

              <div className="px-4 pb-4">
                <h6>
                  Do you have Company House Number? (If not, just click on
                  close)
                </h6>
                <form onSubmit={handleApi}>
                  <input
                    type="text"
                    value={number}
                    maxLength={8}
                    required
                    onChange={e => setnumber(e.target.value)}
                    className="form-control input-field"
                    placeholder="Enter Your Company House Number"
                  />

                  <div className="text-center mt-4">
                    <LoadingButton loading={loading} btnText="Get Details" />
                    <button
                      type="button"
                      className="btn btn-danger ms-3"
                      onClick={() => setPopup(false)}
                    >
                      <i className="fas fa-times me-1"></i> Close
                    </button>
                  </div>
                </form>
              </div>
            </ModalBody>
          </div>
        </Modal>
      )}

      {/* Updated history modal — Individual only */}
      {isIndividual && (
        <Modal
          size="xl"
          isOpen={show}
          toggle={() => setShow(!show)}
          centered={true}
        >
          <div className="modal-content">
            <ModalBody className="px-3 ">
              <div className="d-flex justify-content-between">
                <h5>Updated History</h5>
                <button
                  type="button"
                  className="btn-close "
                  onClick={() => setShow(!show)}
                ></button>
              </div>
              <div
                style={{
                  maxHeight: "550px",
                  overflow: "auto",
                  scrollbarWidth: "thin",
                }}
              >
                <table
                  className="table mt-3"
                  style={{ verticalAlign: "middle" }}
                >
                  <thead className="table-primary">
                    <tr>
                      <th>Sr. No</th>
                      <th>Date</th>
                      <th>User</th>
                      <th>Previous Data</th>
                      <th>Updated Data</th>
                    </tr>
                  </thead>
                  <tbody>
                    {history
                      .slice()
                      .reverse()
                      .map((item, i) => (
                        <tr key={item.id}>
                          <td>{i + 1}</td>
                          <td>
                            {moment(item.createdAt).format(
                              "DD-MM-YYYY | hh:mm A"
                            )}
                          </td>
                          <td>{item.updatedBy}</td>
                          <td>
                            <table border="1" className="table">
                              <tbody className="table-light">
                                {Object.entries(
                                  JSON.parse(item?.previousData)
                                ).map(([key, value]) => (
                                  <tr key={key}>
                                    <th className="py-2 w-50">
                                      {key
                                        .replace(/([A-Z])/g, " $1")
                                        .replace(/^./, str =>
                                          str.toUpperCase()
                                        )}
                                    </th>
                                    <td className="py-2">{value}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </td>
                          <td>
                            <table border="1" className="table">
                              <tbody className="table-light">
                                {Object.entries(
                                  JSON.parse(item?.updatedData)
                                ).map(([key, value]) => (
                                  <tr key={key}>
                                    <th className="py-2 w-50">
                                      {key
                                        .replace(/([A-Z])/g, " $1")
                                        .replace(/^./, str =>
                                          str.toUpperCase()
                                        )}
                                    </th>
                                    <td className="py-2">{value}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </ModalBody>
          </div>
        </Modal>
      )}
    </>
  )
}

export default React.memo(CreateClient)
